// tslint:disable max-line-length
import React from 'react';

const MyElearning = () => (
  <g>
    <path
      d="M5.55381 22.1495C5.09382 22.1495 4.69495 21.9806 4.35718 21.6429C4.01943 21.3051 3.85056 20.9062 3.85056 20.4463V3.55385C3.85056 3.09224 4.01943 2.69196 4.35718 2.35303C4.69495 2.01408 5.09382 1.8446 5.55381 1.8446H18.4462C18.9078 1.8446 19.3081 2.01408 19.647 2.35303C19.986 2.69196 20.1555 3.09224 20.1555 3.55385V20.4463C20.1555 20.9062 19.986 21.3051 19.647 21.6429C19.3081 21.9806 18.9078 22.1495 18.4462 22.1495H5.55381ZM5.55381 20.4463H18.4462V3.55385H17.012V10.2039L14.587 8.80385L12.162 10.2039V3.55385H5.55381V20.4463Z"
      fill="#545454"
    />
  </g>
);

export default MyElearning;
